const objectFromEntries = (entries: [string, any][]) => (Object.fromEntries(entries));

export default objectFromEntries;
